





































import Vue from 'vue'
import { mapState } from 'vuex'
import style from './style.module.scss'

import stepProgress from './step-progress.vue'
import stepOne from '@/components/root-components/supplier-search/step-one/step-one.vue';
import stepTwo from '@/components/root-components/supplier-search/step-two/step-two.vue';

import sign from '@/components/root-components/auth/sign.vue';
import result from '@/components/root-components/result/result.vue';
import error from '@/components/root-components/error/error.vue';

import modalWorkboard from '@/components/common/modal/modal-workboard.vue'
import loader from '@/components/common/loader/loader.vue'

import { ProductMainInfo, Project, FormModeType } from '@/types/supplier-search'
import config from '../../../config';
import { yandexMetrika } from '../../root-components/supplier-search/yandex-metrika-mixin';

export default Vue.extend({
    name: 'supplier-search-page',
    mixins: [yandexMetrika],
    components: {
        stepOne,
        stepTwo,
        sign,
        result,
        error,
        modalWorkboard,
        stepProgress,
        loader
    },
    props: {
        ignite: Boolean,
        dataFromBus: Object as () => ProductMainInfo,
    },
    async mounted() {
        await this.$store.dispatch('getUserInfo');
        this.$store.dispatch('getRegionsKladrList');
        this.$store.dispatch('getProjectsInfo')
    },
    data() {
        return {
            style: style,
            step: 'one',
            showForm: false,
            showSuccess: false,
            showError: false,
            isNewUser: false,
            loading: false,
            currentProductId: -1
        }
    },
    methods: {
        turnOff(): void {
            this.showForm = false;
            this.step = 'one';
            this.$emit('off');
            this.$root.$emit('clearOkpd2List');
            this.$root.$emit('clearOkved2List');
            this.$root.$emit('clearFilledCodes');
            this.$root.$emit('clearOkatoList');
            this.$root.$emit('clearInitRendering');
            this.$root.$emit('clearPositionPriceAndBudget');
            this.$store.dispatch('clearStore');
        },
        runPage(data: ProductMainInfo): void {
            const rootFormModeType = this.$root.$data.formModeType;
            this.$store.dispatch('setMode', rootFormModeType);

            switch (rootFormModeType) {
                case FormModeType.ByProduct:
                    this.runByProductSSF(data);
                    break;
                case FormModeType.Origin:
                    this.runOriginSSF(data);
                    break;

                default:
                    break;
            }
        },
        runByProductSSF(data: ProductMainInfo) {
            if(this.currentProductId !== data.ProductId) this.step = 'one'

            this.currentProductId = data.ProductId;

            this.$store.dispatch('setMainProductinfo', data);
            this.$store.dispatch('copyCharacteristicsToPosition');
            this.showForm = true;
        },
        runOriginSSF(data: ProductMainInfo) {
            this.$store.dispatch('setMainProductinfo', data);
            this.showForm = true;
        },
        back() {
            switch (this.step) {
                case 'two':
                    this.step = 'one'
                    break;
                case 'three':
                    this.step = 'two'
                    break;

                default:
                    break;
            }
        },
        async onAuthenticated(isNewUser: boolean) {
            if (this.step === 'three') {
                await this.sendProject();
                this.isNewUser = isNewUser;
                this.showResult();
                this.resetBudget();
            }
        },
        async sendProject() {
            this.loading = true;
            if (this.isNewProject) {
                await this.$store.dispatch('saveProject')
            } else {
                await this.$store.dispatch('updateProject')
            }
            this.$store.dispatch('getProjectsInfo')


            this.emitSentEvent();
            this.loading = false;
        },
        showResult() {
            this.turnOff();

            if (this.errorMessage) {
                this.showError = true;
            }
            else {
                (this as any).sendToYandexMetrikaTtCreated();
                this.showSuccess = true;
            }
        },
        goToTender() {
            this.showSuccess = false;
            window.location.href = config.ssoSiteUrl + '/Login.aspx?ReturnUrl=' + encodeURIComponent(config.tradeUrl + this.tradeId);
        },
        resumeShoping() {
            this.turnOff();
            this.showSuccess = false;
        },
        emitSentEvent() {
            if (window.supplierSearchEventBus) {
                window.supplierSearchEventBus.$emit('requestSent');
            }
        },
        resetBudget() {
            this.$store.dispatch('setCurrentPositionPrice', 0);
            this.$store.dispatch('setCurrentPositionBudget', 0);
        }
    },
    computed: {
        ...(mapState<RootStateSupplierSearch>({
            isNewProject(state: RootStateSupplierSearch) {
                return state.isNewProject;
            },
            isNewPosition(state: RootStateSupplierSearch) {
                return state.isNewPosition;
            },
            currentProject(state: RootStateSupplierSearch): Project {
                return state.currentProject;
            },
            tradeId(state: RootStateSupplierSearch): number | undefined {
                return state.tradeId;
            }
        }) as MapStateToComputed<RootStateSupplierSearch>),
        isAuthentificated(): boolean {
            return this.$store.getters.isAuthentificated;
        },
        errorMessage(): string {
            return this.$store.getters.errorMessage;
        },
        registrationNote(): string {
            return this.step === 'three'
                ? 'Зарегистрируйтесь, чтобы создать новый запрос.'
                : 'Зарегистрируйтесь, чтобы создать новый запрос.';
        },
        loginNote(): string {
            return this.step === 'three'
                ? 'Авторизуйтесь, чтобы создать новый запрос.'
                : 'Авторизуйтесь, чтобы посмотреть ранее созданные запросы.';
        }
    },
    watch: {
        ignite(ignition: boolean) {
            if(ignition) this.runPage(this.dataFromBus)
        }
    }
})
